/**
 * Created by intellicar-rinas on 4/10/17.
 */
import $http from "../helpers/$http";
import { API_HOST } from "../constants/constants";
import apiHelper from "../helpers/apiHelper";
import { handleGetAlarmHistory } from "../helpers/apiHelper";

const ReportAPIs = {
  getClutchData: (body) => {
    return $http
      .post(API_HOST + "/api/reports/clutchpedal/trackhistory", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },
  getBrakeData: (body) => {
    return $http
      .post(API_HOST + "/api/reports/brakepedal/trackhistory", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },
  getAccelData: (body) => {
    return $http
      .post(API_HOST + "/api/reports/accpedal/trackhistory", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },

  getRTGPS: (body) => {
    return $http
      .post(API_HOST + "/api/reports/rtgps/trackhistory", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },

  getSwiggyReport: (body) => {
    return $http
    .post(API_HOST + "/api/reports/getorders", body)
    .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },

  getLatestCanData: (body) => {
    return $http
      .post(API_HOST + "/api/reports/getlatestcandata", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },

  getCanDataDump: (body) => {
    return $http
      .post("https://blackbox-api.intellicar.in/api/reports/candatadumpvehno", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },
  getCanMetrics :(body) => {
    return $http
      .post(API_HOST + "/api/reports/getcanmetrics", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },
  
  getRideReport: (body) => {
    return $http
      .post(API_HOST + "/api/reports/getridereport", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },

  getAlarmHistory: (body) => {
    return $http
      .post(API_HOST + "/api/reports/alarm/trackhistory", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure)
      .then(handleGetAlarmHistory, apiHelper.validateFailure);
  },

  getRPMInfo: (body) => {
    return $http
      .post(API_HOST + "/api/reports/rpm/trackhistory", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },

  getEngineTempInfo: (body) => {
    return $http
      .post(API_HOST + "/api/reports/coolant/trackhistory", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },

  getBatteryInfo: (body) => {
    return $http
      .post(API_HOST + "/api/reports/battery/trackhistory", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },
  getBatteryTemp: (body) => {
    return $http
      .post(API_HOST + "/api/reports/battemp/trackhistory", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },
  getBatteryCurrent: (body) => {
    return $http
      .post(API_HOST + "/api/reports/current/trackhistory", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },
  getBatteryVoltage: (body) => {
    return $http
      .post(API_HOST + "/api/reports/tork/batteryvoltage/trackhistory", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },

  getFuelLevelInfo: (body) => {
    return $http
      .post(API_HOST + "/api/reports/fuellevel/trackhistory", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },

  getFuelConsumed: (body) => {
    return $http
      .post(API_HOST + "/api/reports/getfuel", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },

  getOdometerInfo: (body) => {
    return $http
      .post(API_HOST + "/api/reports/odometer/trackhistory", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },

  getSpeedInfo: (body) => {
    return $http
      .post(API_HOST + "/api/reports/speed/trackhistory", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },

  getDistance: (body) => {
    return $http
      .post(API_HOST + "/api/reports/getdistance", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },

  getACInfo: (body) => {
    return $http
      .post(API_HOST + "/api/reports/ac/trackhistory", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },

  getSeatBeltInfo: (body) => {
    return $http
      .post(API_HOST + "/api/reports/seatbelt/trackhistory", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },

  getMagnetInfo: (body) => {
    return $http
      .post(API_HOST + "/api/reports/magnet/trackhistory", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },

  getRSSIInfo: (body) => {
    return $http
      .post(API_HOST + "/api/reports/rssi/trackhistory", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },

  getAmbientLightInfo: (body) => {
    return $http
      .post(API_HOST + "/api/reports/ambientlight/trackhistory", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },

  getNanoBatteryInfo: (body) => {
    return $http
      .post(API_HOST + "/api/reports/nanobattery/trackhistory", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },

  getHeadLightInfo: (body) => {
    return $http
      .post(API_HOST + "/api/reports/headlight/trackhistory", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },

  getGearStateInfo: (body) => {
    return $http
      .post(API_HOST + "/api/reports/gearstate/trackhistory", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },

  getTripHistory: (body) => {
    return $http
      .post(API_HOST + "/api/reports/gettriphistory", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },

  getDailyReport: (body) => {
    return $http
      .post(API_HOST + "/api/reports/getvehdailytripreport", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },

  getSummaryReport: (body) => {
    return $http
      .post(API_HOST + "/api/reports/getvehsummarytripreport", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },

  getRefuelHistory: (body) => {
    return $http
      .post(API_HOST + "/api/reports/refuelreport", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },

  getRefuelHistoryList: (body) => {
    return $http
      .post(API_HOST + "/api/reports/refuelreportlistformat", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },

  getUserScore: (body) => {
    return $http
      .post(API_HOST + "/api/reports/alarm/trackhistory", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure)
      .then(apiHelper.handleUserScore, apiHelper.validateFailure);
  },

  getScreedHeatingTime: (body) => {
    return $http
      .post(API_HOST + "/api/reports/getscreedheatingtime", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure)
      .then(apiHelper.handleUserScore, apiHelper.validateFailure);
  },

  lowGearHighGearDistance: (body) => {
    return $http
      .post(API_HOST + "/api/reports/lowgearhighgeardistance", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },

  getPaverPopupMetrics: (body) => {
    return $http
      .post(API_HOST + "/api/reports/getpaverpopupmetrics", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },

  getVolvoCompactorMetrics: (body) => {
    return $http
      .post(API_HOST + "/api/reports/volvocompactor/getmetrics", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },

  getBaseScreedTemperature: (body) => {
    return $http
      .post(
        API_HOST + "/api/reports/base_screed_temperature/trackhistory",
        body
      )
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },

  getLeftScreedTemperature: (body) => {
    return $http
      .post(
        API_HOST + "/api/reports/left_screed_temperature/trackhistory",
        body
      )
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },

  getRightScreedTemperature: (body) => {
    return $http
      .post(
        API_HOST + "/api/reports/right_screed_temperature/trackhistory",
        body
      )
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },

  getActualEngineSpeed: (body) => {
    return $http
      .post(API_HOST + "/api/reports/actualenginespeed/trackhistory", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },

  getEngineHours: (body) => {
    return $http
      .post(API_HOST + "/api/reports/enginehours/trackhistory", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },

  getPavingDistance: (body) => {
    return $http
      .post(API_HOST + "/api/reports/pavingdistance/trackhistory", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },

  getTravelDistanceHighGear: (body) => {
    return $http
      .post(API_HOST + "/api/reports/traveldistancehighgear/trackhistory", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },

  getTravelDistanceLowGear: (body) => {
    return $http
      .post(API_HOST + "/api/reports/traveldistancelowgear/trackhistory", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },

  getBatteryChargeIndication: (body) => {
    return $http
      .post(
        API_HOST + "/api/reports/batterychargeindication/trackhistory",
        body
      )
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },

  getLowGearMoving: (body) => {
    return $http
      .post(API_HOST + "/api/reports/worktimerlowgearmoving/trackhistory", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },

  getLowGearIdle: (body) => {
    return $http
      .post(API_HOST + "/api/reports/worktimerlowgearidle/trackhistory", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },

  getScreenHeatingMode: (body) => {
    return $http
      .post(API_HOST + "/api/reports/screedheatingmode/trackhistory", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },

  getWorkTimeHours: (body) => {
    return $http
      .post(API_HOST + "/api/reports/worktimehours/trackhistory", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },

  getTirePressure: (body) => {
    return $http
      .post(API_HOST + "/api/reports/tirepressure/trackhistory", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },

  getTireTemp: (body) => {
    return $http
      .post(API_HOST + "/api/reports/tiretemp/trackhistory", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },

  getVehicleSummary: (body) => {
    return $http
      .post(API_HOST + "/api/reports/getvehiclesummary", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },

  getTPMSHistory: (body) => {
    return $http
      .post(API_HOST + "/api/reports/gettpmshistory", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },

  getBatteryHealthForAllVehicles: (body) => {
    return $http
      .post(API_HOST + "/api/reports/battery/health/allvehicles", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },

  getBatteryHealth: (body) => {
    return $http
      .post(API_HOST + "/api/reports/battery/health", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },

  getMileage: (body) => {
    return $http
      .post(API_HOST + "/api/reports/mileage/trackhistory", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },

  clutchUsageReport: (body) => {
    return $http
      .post(API_HOST + "/api/reports/clutchusagescore", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },

  clutchLiabilityReport: (body) => {
    return $http
      .post(API_HOST + "/api/reports/clutchliability", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },

  soundTypeHistory: (body) => {
    return $http
      .post(API_HOST + "/api/reports/soundtype/trackhistory", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },

  signTypeHistory: (body) => {
    return $http
      .post(API_HOST + "/api/reports/signtype/trackhistory", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },

  mobileyeTamper: (body) => {
    return $http
      .post(API_HOST + "/api/reports/mobileyetamper/trackhistory", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },

  pilferageReport: (body) => {
    return $http
      .post(API_HOST + "/api/reports/pilferagereport", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },

  pilferageReportList: (body) => {
    return $http
      .post(API_HOST + "/api/reports/pilferagereportlistformat", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },

  getTvsHistory: (body) => {
    return $http
      .post(API_HOST + "/api/reports/tvs/trackhistory", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },

  getTemperatureHistory: (body) => {
    return $http
      .post(API_HOST + "/api/reports/temperature/trackhistory", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },

  torkCurrentHistory: (body) => {
    return $http
      .post(API_HOST + "/api/reports/tork/current/trackhistory", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },

  torkVoltageHistory: (body) => {
    return $http
      .post(API_HOST + "/api/reports/tork/voltage/trackhistory", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },

  torkMotorTempHistory: (body) => {
    return $http
      .post(API_HOST + "/api/reports/tork/motortemp/trackhistory", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },

  torkECUTempHistory: (body) => {
    return $http
      .post(API_HOST + "/api/reports/tork/ecutemp/trackhistory", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },

  torkTorqueHistory: (body) => {
    return $http
      .post(API_HOST + "/api/reports/tork/torque/trackhistory", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },

  torkBatteryVoltageHistory: (body) => {
    return $http
      .post(API_HOST + "/api/reports/tork/batteryvoltage/trackhistory", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },

  torkMinCellVoltageHistory: (body) => {
    return $http
      .post(API_HOST + "/api/reports/tork/mincellvoltage/trackhistory", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },

  torkMaxCellVoltageHistory: (body) => {
    return $http
      .post(API_HOST + "/api/reports/tork/maxcellvoltage/trackhistory", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },

  torkControllerTempHistory: (body) => {
    return $http
      .post(API_HOST + "/api/reports/tork/controllertemp/trackhistory", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },

  getTimestampsFromOdometer: (body) => {
    return $http
      .post(API_HOST + "/api/reports/getcanodotimerange", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },

  getFuelPrice: (body) => {
    return $http
      .post(API_HOST + "/api/reports/getfuelprice", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },

  getTrainHistory: (body) => {
    return $http
      .post(API_HOST + "/api/reports/train/trackhistory", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },

  getPulseHistory: (body) => {
    return $http
      .post(API_HOST + "/api/reports/pulse/trackhistory", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },
  getPanicAlertHistory: (body) => {
    return $http
      .post(API_HOST + "/api/reports/fleetpanicalerts", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },
  getDtcReport: (body) => {
    return $http
      .post(API_HOST + "/api/reports/dtc/trackhistorypairs", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },
  getBmsData: (body) => {
    return $http
      .post(API_HOST + "/api/reports/getevbatteryreport", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },

  getEvReport: (body) => {
    return $http
      .post(API_HOST + "/api/reports/ev/genericevreport", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },

  getCanReport: (body) => {
    return $http
      .post(API_HOST + "/api/reports/can/trackhistory", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },

  getHydraulicPressureReport: (body) => {
    return $http
      .post(API_HOST + "/api/reports/hydraulicpressure/trackhistory", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },
  getEVDashboard: (body) => {
    return $http
      .post(API_HOST + "/api/ev/dashboard", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },
  getEVTripReport: (body) => {
    return $http
      .post(
        "https://apiplatform.intellicar.in/api/reports/ev/getevtripreport/v3",
        body
      )
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },
  getEvBatteryVoltage: (body) => {
    return $http
      .post(API_HOST + "/api/reports/getevbatteryvoltage", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },
  getGearMapping: (body) => {
    return $http
      .post(API_HOST + "/api/vehicle/getmodelinfo", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },
  downloadRequest: (body) => { 
    return $http
      .post(API_HOST + "/api/download/startscript", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },
  requestTableAPI: (body) => { 
    return $http
      .post(API_HOST + "/api/download/getdownloadhistory", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },    
  getPrecomputeSummarytrips: (body) => {
    return $http
      .post(API_HOST + "/api/reports/getprecomputesummarytrips", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },
  getPrecomputeDailytrips: (body) => {
    return $http
      .post(API_HOST + "/api/reports/getprecomputedailytrips", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },
  getPrecomputeTrips: (body) => {
    return $http
      .post(API_HOST + "/api/reports/getprecomputetrips", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },
  fileDownload: (body) => {
    return $http
      .post(API_HOST + "/api/download/filedownload", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },
  cancelRequest: (body) => {
    return $http
      .post(API_HOST + "/api/download/canceldownload", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },
  getChargeStatusReport: (body) => {
    return $http
      .post(API_HOST + "/api/reports/getchargestatusreport", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },
  getBlrPoliceLocation: (body) => {
    return $http
      .post(API_HOST + "/api/reports/blrpolicelocation", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },
  graphCanDataDump: (body) => {
    return $http
      .post("https://blackbox-api.intellicar.in/api/reports/graphcandatadump2", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },
  hourlyDistance: (body) => {
    return $http
      .post(API_HOST + "/api/reports/gethourlydistance", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },
  getReportVehicles: (body) => {
    return $http
      .post(API_HOST + "/api/report/getreportvehicles", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },
  listGroupForSurgeReport: (body) => {
    return $http
      .post(API_HOST + "/api/reports/listgroupforsurgereport", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },
  // /api/reports/listgroupforsurgereport
  newPrecomputeTrips: (body) => {
    return $http
      .post(API_HOST + "/api/report/gettripvehiclenew", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },
  getImmobReport: (body) => {
    return $http
      .post(API_HOST + "/api/standard/cmdstatusformultiplevehicles", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },
  latestCmdStatusReport: (body) => {
    return $http
      .post(API_HOST + "/api/standard/latestcmdstatus", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },
  getTripwiseMovement: (body) => {
    return $http
      .post(API_HOST + "/api/reports/gettripwisemovement", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },
  getTripMovementData: (body) => {
    return $http
      .post(API_HOST + "/api/reports/gettripmovementdata", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },
  getChargingHistoryReport: (body)=>{
    return $http
      .post(API_HOST + "/api/reports/zaplist/charginglist", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },
  getUtilizationReport: (body) => {
    return $http
      .post("https://apiplatform.intellicar.in/api/reports/motovolt/utilization", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  }
  // getUtilizationGraph: (body) => {
  //   return $http
  //     .post("https://apiplatform.intellicar.in/api/reports/motovolt/utilization-graph", body)
  //     .then(apiHelper.validateResponse, apiHelper.validateFailure);
  // }
  
};

export default ReportAPIs;
